<script setup lang="ts">
// TODO: Render user profile if logged in
import currentUser from '@@/bits/current_user'
import { __ } from '@@/bits/intl'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzPadletLogo from '@@/library/v4/components/OzPadletLogo.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useWindowSizeStore } from '@@/pinia/window_size'
import SkipToContentLink from '@@/vuecomponents/SkipToContentLink.vue'
import { storeToRefs } from 'pinia'

const darkModeStore = useDarkModeStore()
const { isDarkMode } = storeToRefs(darkModeStore)

const windowSizeStore = useWindowSizeStore()
const { isBiggerThanTabletLandscape } = storeToRefs(windowSizeStore)

const isLoggedIn = currentUser.email !== null
</script>

<template>
  <nav :class="[!isBiggerThanTabletLandscape && 'nav-tablet']">
    <SkipToContentLink />

    <OzPadletLogo :dark-mode="isDarkMode" class="w-20 h-5" />
    <div v-if="!isLoggedIn" class="flex justify-end flex-wrap gap-2">
      <OzContainedButton
        href="/auth/login"
        :text="__('Log in')"
        :color-scheme="OzContainedButtonColorScheme.Alternative"
        :size-preset="OzContainedButtonSizePreset.H32px"
      />
      <OzContainedButton href="/auth/signup" :text="__('Sign up')" :size-preset="OzContainedButtonSizePreset.H32px" />
    </div>
  </nav>
</template>

<style lang="scss" scoped>
nav {
  width: 100%;
  background: var(--nav-background-color);
  box-sizing: border-box;
  padding: 20px 24px 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;

  .padlet-logo {
    margin-bottom: 8px;
  }
}

nav.nav-tablet {
  padding: 20px 14px 12px 8px;
}
</style>
